module.exports = __webpack_public_path__ + "img/avatar5.612aec3c.png";